import { render, staticRenderFns } from "./PartnerGroupSubscription.vue?vue&type=template&id=2e5635da&"
import script from "./PartnerGroupSubscription.vue?vue&type=script&lang=js&"
export * from "./PartnerGroupSubscription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports